/* Shopify is the source of truth for prices, variants, stock and article URLs. */
(function(){
  'use strict';
  const read=id=>JSON.parse(document.getElementById(id)?.textContent||'[]');
  const live=read('freya-live-products');
  const originals=window.FREYA_PRODUCTS||[];
  window.FREYA_PRODUCTS=originals.flatMap(p=>{
    const current=live.find(n=>n.variants.some(v=>p.variants?.some(old=>String(old.id)===v.id)));
    if(!current)return [];
    return [{...p,...current,backImage:p.backImage?current.backImage:null,
      sizes:current.variants.map(v=>v.label).filter(x=>x!=='Default Title').join(' / ')||p.sizes,
      price:current.priceVaries?null:current.price,priceFrom:current.price,
      variants:current.variants.map(v=>({...v,label:v.label==='Default Title'?'Standart':v.label}))}];
  });
  window.FREYA_RECIPES=(window.FREYA_RECIPES||[]).map(r=>{
    const local=r.image||'images/recipes/'+r.slug+(r.slug==='maviyemis-lavanta-ve-orman-meyveli-pavlova'?'.png':'.jpg');
    return {...r,image:window.FREYA_ASSETS[local]||local};
  });
  const previous=window.FREYA_BLOG_POSTS||[];
  window.FREYA_BLOG_POSTS=read('freya-live-posts').map(p=>{
    const old=previous.find(o=>decodeURIComponent(new URL(o.url,location.origin).pathname)===decodeURIComponent(p.url));
    return {...p,category:old?.category||'Freya’dan',excerpt:old?.excerpt||p.excerpt,slug:old?.slug||p.slug};
  });
  window.FREYA_SHOP=read('freya-shop-context');
  if(document.getElementById('freya-recipe-index')){
    const isRecipe=new URLSearchParams(location.search).has('tarif') || window.FREYA_RECIPES.some(r=>r.sourcePath===location.pathname);
    const index=document.getElementById('freya-recipe-index'),detail=document.getElementById('recipe-detail');
    if(isRecipe){index?.remove();if(detail)detail.hidden=false;}else detail?.remove();
  }
})();
